import { Badge } from 'src/@/components/ui/badge';
import Iconify from 'src/components/Iconify';
import { fDateTime } from 'src/utils/formatTime';
import { CHAMADOS_DESIGN } from './Chamados.design';

const STATUS_CONFIG = {
  pendente: { label: 'Pendente', ...CHAMADOS_DESIGN.badges.pendente },
  aberto: { label: 'Aberto', ...CHAMADOS_DESIGN.badges.aberto },
  recusado: { label: 'Recusado', ...CHAMADOS_DESIGN.badges.recusado },
  concluido: { label: 'Concluido', ...CHAMADOS_DESIGN.badges.concluido },
  cancelado: { label: 'Cancelado', ...CHAMADOS_DESIGN.badges.cancelado },
};

export default function ChamadosRowTableNew({ row, onViewRow }) {
  const { assunto, status, data_criacao, nome_autor, completado, chamado, ultima_modificacao, data_para_conclusao, tipo } = row;
  const isLate = data_para_conclusao && new Date() > new Date(data_para_conclusao);
  const statusCfg = STATUS_CONFIG[status] || STATUS_CONFIG.pendente;

  return (
    <div
      onClick={onViewRow}
      className={isLate ? CHAMADOS_DESIGN.row.containerLate : CHAMADOS_DESIGN.row.container}
    >
      <div className="w-[140px] flex items-center gap-2">
        <span className="text-sm font-medium text-gray-900">#{chamado}</span>
        {tipo === 'externo' ? (
          <Badge variant="outline" className="text-[9px] font-semibold px-1.5 py-0 h-4 bg-orange-50 text-orange-700 border-orange-200">
            Externo
          </Badge>
        ) : (
          <Badge variant="outline" className="text-[9px] font-semibold px-1.5 py-0 h-4 bg-blue-50 text-blue-700 border-blue-200">
            Interno
          </Badge>
        )}
      </div>
      <div className="flex-1 min-w-[200px] pr-4 text-sm text-gray-700 truncate">{assunto}</div>
      <div className="w-[120px]">
        <Badge variant="outline" className={statusCfg.container}>
          <span className={statusCfg.dot} />
          {statusCfg.label}
        </Badge>
      </div>
      <div className="w-[150px] text-xs text-gray-500">{fDateTime(data_criacao)}</div>
      <div className="w-[150px] text-xs text-gray-500">{fDateTime(data_para_conclusao)}</div>
      <div className="w-[150px] text-xs text-gray-500">{fDateTime(ultima_modificacao)}</div>
      <div className="w-[120px] text-xs text-gray-600 truncate">{nome_autor}</div>
      <div className="w-[90px]">
        <Badge variant="outline" className={completado
          ? 'text-xs bg-green-50 text-green-700 border-green-200'
          : 'text-xs bg-red-50 text-red-700 border-red-200'
        }>
          {completado ? 'Sim' : 'Nao'}
        </Badge>
      </div>
      <div className="w-[40px] flex justify-end">
        <button
          onClick={(e) => { e.stopPropagation(); onViewRow(); }}
          className="p-1.5 rounded-lg text-gray-400 hover:bg-violet-50 hover:text-violet-600 transition-all"
        >
          <Iconify icon="eva:arrow-ios-forward-outline" width={18} />
        </button>
      </div>
    </div>
  );
}
